import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../shared';
import { MerchantContractContainerModel } from '../../../../../models/aggregates/pgw/merchant-contract.model';

@Injectable({
  providedIn: 'root',
})
export class ExternalMerchantContractService extends BaseApiTemplateService<MerchantContractContainerModel> {
  
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + 'merchant-contract-hdr/merchant-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + 'merchant-contract-hdr/merchant-ep';
    this.httpClient = http;
  }
}
